import React, { Fragment, useState, useEffect } from "react";
import { PaymentContainer, HyperLink } from "../../PaymentHistory/Styles";
import { TableWrapper } from "../../FinalApprover/index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "../../FinalApprover/component/CustomTable";
import { getErrorMessage, getFileName } from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import { Bold } from "../../RecordingsPage";
import NoticeService from "../../../../services/NoticeService";
import DeleteIcon from "@material-ui/icons/Delete";
import useAlert from "../../../../hooks/useAlert";
import useLoader from "../../../../hooks/useLoader";

async function getTrackingList(query = "") {
  try {
    const response = await NoticeService.getTrackingList(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const ArbitratorMeeting = ({
  MTRef,
  setValue,
  setFieldValue,
  page,
  setTrackingToken,
}) => {
  const [state, setState] = useState({});
  const placeholderText = "Search";
  const { enqueueSnackbar } = useSnackbar();
  const { hideAlert, showAlert } = useAlert();
  const { setLoader } = useLoader();

  useEffect(() => {
    async function trackingToken() {
      try {
        setLoader({ state: true, message: "fetching" });
        const response = await NoticeService.trackingToken();
        if (response?.success === false) {
          enqueueSnackbar("Connection Error", {
            variant: "error",
          });
        }
        if (response?.success === true) {
          setTrackingToken(response?.token);
        }
      } catch (err) {
        enqueueSnackbar();
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    trackingToken(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (MTRef.current) {
      setFieldValue("page", MTRef.current.state.query.page);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MTRef.current]);

  async function deleteTrackingList(id) {
    try {
      setLoader({ state: true, message: "Delete Tracking list..." });
      const response = await NoticeService.deleteTrackingList({ id });
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      hideAlert();
      MTRef.current.onQueryChange("");
    }
  }

  const columns = [
    {
      field: "id",
      title: "Id",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            setValue(1);
            setFieldValue("trackingMetaData", rowData);
          }}
        >
          {rowData?.id}
        </HyperLink>
      ),
      headerStyle: {
        width: 20,
      },
      cellStyle: {
        width: 20,
      },
    },
    {
      field: "uploader_name",
      title: "Uploaded By",
      sorting: false,
      render: (rowData) => rowData?.uploader_name,
    },
    {
      field: "uploader_email",
      title: "Uploaded Email",
      sorting: false,
      render: (rowData) => rowData?.uploader_email,
    },
    {
      field: "tracking_file",
      title: "Tracking File",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          style={{
            width: "170px",
            textDecoration: "underline",
            cursor: "pointer",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
          onClick={() => {
            setValue(1);
            setFieldValue("trackingMetaData", rowData);
          }}
        >
          {getFileName(rowData?.tracking_file)}
        </HyperLink>
      ),
    },
    {
      field: "created_at",
      title: "Created",
      sorting: false,
      render: (rowData) =>
        rowData?.created_at ? (
          <Bold>{rowData?.created_at}</Bold>
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
    {
      field: "",
      title: "Action",
      sorting: false,
      render: (rowData) =>
        rowData?.tracking_file ? (
          <DeleteIcon
            style={{
              fill: "#d91b1b",
              cursor: "pointer",
              fontSize: 20,
              marginLeft: "15px",
            }}
            onClick={() =>
              showAlert({
                heading: "Delete Tracking List?",
                desc: `Are you sure you want to Delete the tracking list?`,
                primaryBtnText: "Delete",
                secondaryBtnText: "Cancel",
                clickSecondarybtn: () => hideAlert(),
                clickPrimaryBtn: () => {
                  deleteTrackingList(rowData.id);
                },
                isOpen: true,
                onDialogClose: () => hideAlert(),
              })
            }
          />
        ) : (
          <div style={{ paddingLeft: "15px" }}>{"-"}</div>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: page ? page : query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `?${queryString.stringify(params)}`;
      }
      getTrackingList(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        <TableWrapper>
          <CustomTable
            selection={false}
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Tracking Details"}
            singularTitle=""
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
              setFieldValue,
            }}
            hideFilterBar
            state={state}
          />
        </TableWrapper>
      </PaymentContainer>
    </Fragment>
  );
};

export default ArbitratorMeeting;
